import { defineComponent as _defineComponent } from 'vue'
import { useViewport } from '@travelata-libs/utils';
  import logoEmirates from '@/img/logos/logo-emirates.png';

  interface Props {
    title?: string;
    linkUrl?: string;
    logoSrc?: string;
    logoAlt?: string;
    buttonText?: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SpecialOfferBanner',
  props: {
    title: { default: 'Специальное предложение в ОАЭ из МСК и СПБ' },
    linkUrl: { default: '/search#?toCountry=68&fromCity=2&block=true&hotelClass=8.7' },
    logoSrc: { default: logoEmirates },
    logoAlt: { default: 'travelata-emirates logo' },
    buttonText: { default: 'Смотреть туры' }
  },
  setup(__props: any) {

const props = __props as { title: string, linkUrl: string, logoSrc: string, logoAlt: string, buttonText: string }

  

  const { isMobile } = useViewport();

  const openSpecialOffer = () => {
    window.open(props.linkUrl, '_self');
  };

return { __sfc: true,props, isMobile, openSpecialOffer }
}

})